import { createContext, useContext } from 'react';
export const FieldValidationContext = /*#__PURE__*/createContext(null);
export const useFieldValidation = () => useContext(FieldValidationContext) || {};
//# sourceMappingURL=field-validation-context.js.map